import React from 'react';
import {
  Accessibility,
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BarChart3,
  Building,
  Building2,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  CalendarRange,
  Car,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clapperboard,
  Clock,
  Coffee,
  Compass,
  Crown,
  Disc3,
  DoorOpen,
  DollarSign,
  Drama,
  Hammer,
  Image,
  MessagesSquare,
  Navigation2,
  Mic,
  PersonStanding,
  ExternalLink,
  Eye,
  EyeOff,
  Flag,
  Footprints,
  Gift,
  Heart,
  HelpCircle,
  Home,
  Infinity as InfinityIcon,
  Info,
  Languages,
  Lightbulb,
  List,
  Loader,
  Loader2,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize2,
  Mic2,
  Music,
  Palette,
  PartyPopper,
  Pause,
  Play,
  Search,
  Settings,
  Share2,
  Shapes,
  Shield,
  Shirt,
  ShoppingBag,
  SlidersHorizontal,
  Smile,
  Sparkles,
  Star,
  Tag,
  Target,
  ThumbsDown,
  ThumbsUp,
  TramFront,
  Trash2,
  Trees,
  TrendingUp,
  Trophy,
  User,
  Users,
  UtensilsCrossed,
  Waves,
  Wrench,
  X,
  Zap
} from 'lucide-react';

const iconMap = {
  Accessibility,
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BarChart3,
  Building,
  Building2,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  CalendarRange,
  Car,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clapperboard,
  Clock,
  Coffee,
  Compass,
  Crown,
  Disc3,
  DoorOpen,
  Dollar: DollarSign,
  DollarSign,
  Drama,
  Hammer,
  Image,
  MessagesSquare,
  Navigation2,
  Mic,
  PersonStanding,
  ExternalLink,
  Eye,
  EyeOff,
  Flag,
  Footprints,
  Gift,
  Heart,
  HelpCircle,
  Home,
  Infinity: InfinityIcon,
  Info,
  Languages,
  Lightbulb,
  List,
  Loader,
  Loader2,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize2,
  Mic2,
  Music,
  Palette,
  PartyPopper,
  Pause,
  Play,
  Search,
  Settings,
  Share2,
  Shapes,
  Shield,
  Shirt,
  ShoppingBag,
  SlidersHorizontal,
  Smile,
  Sparkles,
  Star,
  Tag,
  Target,
  ThumbsDown,
  ThumbsUp,
  TramFront,
  Trash2,
  Trees,
  TrendingUp,
  Trophy,
  User,
  Users,
  UtensilsCrossed,
  Waves,
  Wrench,
  X,
  Zap
};

// The names `<Icon name="…" />` accepts. An unregistered name does not throw — it renders
// a grey "?" — so `src/tests/components/iconNames.test.js` checks every literal name in the
// app against this list rather than waiting for someone to notice a question mark.
export const ICON_NAMES = Object.keys(iconMap);

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;
